module.exports = __webpack_public_path__ + "static/img/female-bg-pt.aae0275a.png";